module.exports = __webpack_public_path__ + "img/qr-ctop-homecenter-dev.3d4a2ff3.png";